/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";

import {
  CredentialDetailService,
  ICredentialDetailMethods,
  ILoadingMethods,
  LoadingService,
  IStaticPageContentMethods,
  StaticPageContentService,
  IDraftCredentialDetailMethods,
  DraftCredentialDetailService
} from "./components";

export type CredentialPageAgent = ICredentialDetailMethods &
  IStaticPageContentMethods &
  IDraftCredentialDetailMethods &
  ILoadingMethods;

const getPlugins = () => {
  return [
    new CredentialDetailService(),
    new LoadingService(),
    new StaticPageContentService(),
    new DraftCredentialDetailService(),
  ];
};

export const getAgent = () => {
  return createAgent<CredentialPageAgent>({
    plugins: getPlugins(),
  });
};
